module.exports = __webpack_public_path__ + "fonts/fa-solid-900.412a43d.woff2";